/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useGridStyle } from '../../../utils/styles/grid'
import FormHandler, { useFormState } from './FormHandler'

const Form = ({ loading, children, ...props }) => {
  const style = css`
    ${useGridStyle(props)}
  `

  const { handleSubmit } = useFormState()

  return (
    <form className="form" onSubmit={!loading ? handleSubmit : undefined} css={style}>
      {children}
    </form>
  )
}

const Wrapper = ({ children, ...props }) => (
  <FormHandler {...props}>
    <Form {...props}>{children}</Form>
  </FormHandler>
)

export default Wrapper
